import * as e from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/EyeClosed.es.js";
const o = e.forwardRef((r, s) => /* @__PURE__ */ e.createElement(t, { ref: s, ...r, weights: a }));
o.displayName = "EyeClosedIcon";
const n = o;
export {
  n as EyeClosed,
  o as EyeClosedIcon
};
